import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from './Header';
import Sidebar from './Sidebar';
// import CountdownBar from '../countdown/CountdownBar';

const Layout = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <Header 
        user={user} 
        onToggleSidebar={toggleSidebar}
        sidebarOpen={sidebarOpen}
      />
      
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <Sidebar 
          user={user} 
          isOpen={sidebarOpen}
          onToggle={toggleSidebar}
        />
        {/* Countdown */}
         {/* <CountdownBar /> */}
        {/* Main Content */}
        <main className={`flex-grow-1 main-content ${sidebarOpen ? 'sidebar-open' : ''}`}>
          <div className="container-fluid">
            {/* ganti {children} → <Outlet /> */}
            <Outlet />
            {/* {children} */}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout; 